import { useMutation, useQueryClient } from '@tanstack/vue-query';

import { createUser, deleteUser, updateUser } from '../api';
import { handleUserChangeSuccess } from './handlers/handleUserChangeSuccess';

export const useCreateUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createUser,
    onSuccess: handleUserChangeSuccess(queryClient),
  });
};

export const useUpdateUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateUser,
    onSuccess: handleUserChangeSuccess(queryClient),
  });
};

export const useDeleteUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteUser,
    onSuccess: handleUserChangeSuccess(queryClient),
  });
};
